import {FuelCardTypeEnum} from '@/services/api-clients';

export function fuelCardTypeNameFilter(type: FuelCardTypeEnum): string {
  switch (type) {
    case FuelCardTypeEnum.CircleK: return 'CircleK';
    case FuelCardTypeEnum.Orlen: return 'Orlen';
    case FuelCardTypeEnum.Amic: return 'Amic';
    default: return ''
  }
}
